<template>
  <div
    :class="[
      'asd20-checkbox',
      { 'asd20-checkbox__no-icon': !icon && !checkbox },
      { 'asd20-checkbox__checkbox': !icon && checkbox },
    ]"
  >
    <input
      ref="checkbox"
      :id="id"
      :checked="value"
      :role="!checkbox ? 'switch' : null"
      :aria-checked="value.toString()"
      v-bind="$attrs"
      type="checkbox"
      @change="toggle"
    />
    <label :for="id" @click.prevent="$refs.checkbox.click()">
      <span>{{ label }}</span>
      <span v-if="description" class="asd20-checkbox__description">{{
        description
      }}</span>
      <asd20-badge :visible="!!count" :value="count" static />
    </label>
  </div>
</template>

<script>
import Asd20Badge from '../../../components/atoms/Asd20Badge'
export default {
  name: 'Asd20CheckboxIcon',
  components: { Asd20Badge },
  props: {
    value: { type: Boolean, default: false },
    label: { type: String, default: '' },
    description: { type: String, default: '' },
    count: { type: Number, default: 0 },
    icon: { type: String, default: '' },
    checkbox: { type: Boolean, default: false },
  },
  data() {
    return {
      toggleIcon: this.value,
    }
  },
  computed: {
    id() {
      const base = this.label
        ? this.label.replace(/ /gi, '-').toLowerCase()
        : null
      return base && base.length
        ? `asd20-checkbox-${base}`
        : `asd20-checkbox-${this._uid}`
    },
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value)
      this.toggleIcon = !this.toggleIcon
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

.asd20-checkbox {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  input {
    position: absolute;
    right: 0;
    opacity: 0;
  }

  .asd20-checkbox__icon-box {
    border-left: 0.5px solid var(--color__secondary-t70);
    padding: 0 space(0.5);
  }

  label {
    cursor: pointer;
    user-select: none;
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px 2px 2px 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-weight: normal;
    font-family: var(--website-typography__font-family-body);
    span {
      display: block;
      flex-grow: 1;
      margin-right: space(0.5);
    }
    &::selection {
      background: none;
    }

    .asd20-checkbox__description {
      font-size: 0.75rem;
      margin-left: auto;
      flex-grow: 0;
    }

    .asd20-badge {
      order: 0;
      margin-right: space(0.5);
      flex-shrink: 0;
    }
  }
  &.asd20-checkbox__no-icon {
    label:before {
      content: '';
      display: block;
      width: space(2);
      height: space(1);
      flex-shrink: 0;
      border-radius: space(1);
      background: var(--color__accent-t90);
      box-shadow: 0 0 0 2px var(--color__accent-t50);
      margin-left: auto;
      order: 2;
      transition: all asd20-speed(1) ease-in-out;
    }
    label:after {
      content: '';
      display: block;
      width: space(1);
      height: space(1);
      margin-left: space(-1);
      transform: translate3d(space(-1), 0, 0);
      flex-shrink: 0;
      border-radius: 50%;
      background: white;
      box-shadow: 0 0 0 2px var(--color__accent);
      order: 3;
      transition: all asd20-speed(1) ease-in-out;
    }

    input:checked + label:before {
      background: var(--color__accent);
      box-shadow: 0 0 0 2px var(--color__accent);
    }
    input:checked + label:after {
      transform: translate3d(0, 0, 0);
    }
  }
  &.asd20-checkbox__checkbox {
    input {
      position: absolute;
      left: 1rem;
      right: unset;
      opacity: 1;
    }
  }

  input:focus + label:after {
    @include asd20-focus;
  }
}
</style>
